import React, { useEffect } from 'react';
import TermsPdfViewer from './TermsPdfViewer';
import { useEscapeToClose } from '../../../../hooks/useEscapeToClose';
import styles from './TermsModal.module.css';

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ open, onClose }) => {
  useEscapeToClose(onClose, open);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className={styles.header}>
          <h2 id="terms-modal-title" className={styles.title}>
            Termos de uso e Políticas de Privacidade
          </h2>
          <button
            type="button"
            className={styles.closeButton}
            aria-label="Fechar"
            onClick={onClose}
          >
            <span className="material-symbols-outlined" aria-hidden="true">
              close
            </span>
          </button>
        </header>

        <div className={styles.viewerContainer}>
          <TermsPdfViewer />
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
